
export const getDateInputPattern = (dateValue) => {
    dateValue = dateValue.replace(/\D+/g, '');
    dateValue = dateValue.replace(/^(\d{2})(\d)/, '$1 / $2');
    dateValue = dateValue.replace(/^(\d{2}\s\/\s\d{2})(\d{2})/, '$1 / $2');
    return dateValue.slice(0, 14)
}

export const getDateRequestPattern = (dateValue) => {
    dateValue = dateValue.replace(/\D+/g, '');
    dateValue = dateValue.replace(/^(\d{4})(\d)/, '$1-$2');
    dateValue = dateValue.replace(/^(\d{4}-\d{2})(\d{1})/, '$1-$2');
    return dateValue.slice(0, 10)
}


export const getDateLabelPattern = (dateValue) => {
    return dateValue?.slice(8, 10) + " / " + dateValue?.slice(5, 7) + " / " + dateValue?.slice(0, 4)
}